Instructions on how a candidate should be distributed.
